/* eslint-disable react/no-danger */
import Popup from '@/kenwood/configurator/components/Popup';
import {
  pushAccessoryAddMorePromoAlert,
  pushModalPromoAlert,
} from '@/utils/Controllers/GTM/Operations/Kenwood/Configurator';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const PopupContent = ({ onClose }) => {
  const { t } = useTranslation();
  return (
    <div className='ken-configurator__generic-popup'>
      <button
        className='ken-configurator__generic-popup-close'
        type='button'
        onClick={onClose}
      >
        <img
          className='ken-configurator__generic-popup-close-img'
          src={`${DLG.config.distResourcePath}/assets/images/kenwood/configurator/close.svg`}
          alt={t('configurator:configurator.alt.close')}
        />
      </button>
      <div className='ken-configurator__generic-popup-content'>
        <div
          className='ken-configurator__generic-popup-title'
          dangerouslySetInnerHTML={{
            __html: t('configurator:configurator.gotosummary.popup.title'),
          }}
        />
        <div
          className='ken-configurator__generic-popup-desc'
          dangerouslySetInnerHTML={{
            __html: t(
              'configurator:configurator.gotosummary.popup.description',
            ),
          }}
        />
        <div className='ken-configurator__generic-popup-ctas'>
          <button
            className='ken-hero__textblock-cta ken-hero__textblock-cta--primary'
            type='button'
            onClick={onClose}
          >
            {t('configurator:configurator.gotosummary.popup.action.cancel')}
          </button>
          <Link
            className='ken-hero__textblock-cta ken-hero__textblock-cta--secondary'
            to={`${DLG.config.encodedContextPath}/configurator/step3`}
          >
            {t('configurator:configurator.gotosummary.popup.action.confirm')}
          </Link>
        </div>
      </div>
    </div>
  );
};

const GoToSummaryPopup = ({ isOpen, setIsOpen, isOwner }) => {
  const onCloseHandler = () => {
    pushAccessoryAddMorePromoAlert(isOwner);
    setIsOpen(false);
  };

  useEffect(() => {
    if (isOpen) {
      pushModalPromoAlert(isOwner);
    }
  }, [isOpen]);

  return (
    <Popup isOpen={isOpen}>
      <PopupContent onClose={onCloseHandler} />
    </Popup>
  );
};

PopupContent.propTypes = {
  onClose: PropTypes.func.isRequired,
};

GoToSummaryPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  isOwner: PropTypes.bool.isRequired,
};

export default GoToSummaryPopup;
